<template>

    <div class="row">
        <div class="form-group">
            <label>
                <input type="checkbox" v-model="props.data.checkboxBeneficiary" name="FounderFLIsBeneficiary"
                    :disabled="disabled">
                <span>Бенефициарные владельцы отсутствуют</span>
            </label>
        </div>

    </div>

    <div v-if="!props.data.checkboxBeneficiary" v-for="(item, index) in Beneficiary" :key="index" class="mt-3">

        <div class="row">
            <div class="col-md-8 col-lg-6">
                <!-- 
                <ui-input-box-floating class="mb-3" :error="getError(index, 'BeneficiaryLName')">
                    <ui-input v-model="item.BeneficiaryLName" type="text" placeholder="Фамилия бенефициара"
                        :disabled="disabled" />
                    <ui-input-label>Фамилия бенефициара</ui-input-label>
                </ui-input-box-floating> -->

                <Autocomplete class="mb-3" v-model="item.BeneficiaryLName" type="fio" label="Фамилия бенефициара"
                    :payload="{ parts: ['SURNAME'] }" placeholder="Фамилия бенефициара"
                    :error="getError(index, 'BeneficiaryLName')" :disabled="disabled"
                    @select="(d) => item.BeneficiaryLName = d.value" />

                <div class="row">

                    <div class="col-md-6">

                        <!-- <ui-input-box-floating class="mb-3" :error="getError(index, 'BeneficiaryFName')">
                            <ui-input v-model="item.BeneficiaryFName" type="text" placeholder="Имя бенефициара"
                                :disabled="disabled" />
                            <ui-input-label>Имя бенефициара</ui-input-label>
                        </ui-input-box-floating> -->

                        <Autocomplete class="mb-3" v-model="item.BeneficiaryFName" type="fio" label="Имя бенефициара"
                            :payload="{ parts: ['NAME'] }" placeholder="Имя бенефициара"
                            :error="getError(index, 'BeneficiaryFName')" :disabled="disabled"
                            @select="(d) => item.BeneficiaryFName = d.value" />

                    </div>

                    <div class="col-md-6">
                        <!-- 
                        <ui-input-box-floating class="mb-3" :error="getError(index, 'BeneficiaryMName')">
                            <ui-input v-model="item.BeneficiaryMName" type="text" placeholder="Отчество бенефициара"
                                :disabled="disabled" />
                            <ui-input-label>Отчество бенефициара</ui-input-label>
                        </ui-input-box-floating> -->


                        <Autocomplete class="mb-3" v-model="item.BeneficiaryMName" type="fio"
                            label="Отчество бенефициара" :payload="{ parts: ['PATRONYMIC'] }"
                            placeholder="Отчество бенефициара" :error="getError(index, 'BeneficiaryMName')"
                            :disabled="disabled" @select="(d) => item.BeneficiaryMName = d.value" />

                    </div>

                    <div class="col-md-6">

                        <ui-input-box-floating class="mb-3" :error="getError(index, 'BeneficiaryBD')">
                            <ui-input v-model="item.BeneficiaryBD" type="date" placeholder="Дата рождения"
                                :disabled="disabled" />
                            <ui-input-label>Дата рождения</ui-input-label>
                        </ui-input-box-floating>

                    </div>

                    <div class="col-md-6">

                        <!-- <ui-input-box-floating class="mb-3" :error="getError(index, 'BeneficiaryBPlace')">
                            <ui-input v-model="item.BeneficiaryBPlace" type="text" placeholder="Место рождения"
                                :disabled="disabled" />
                            <ui-input-label>Место рождения</ui-input-label>
                        </ui-input-box-floating> -->

                        <Autocomplete class="mb-3" v-model="item.BeneficiaryBPlace" type="address"
                            label="Место рождения" placeholder="Место рождения"
                            :error="getError(index, 'BeneficiaryBPlace')" :disabled="disabled"
                            @select="(d) => item.BeneficiaryBPlace = d.value" />

                    </div>

                </div>


                <ui-input-box-floating class="mb-3" :error="getError(index, 'BeneficiaryINN')">
                    <ui-input v-model="item.BeneficiaryINN" type="text" placeholder="ИНН" :disabled="disabled" />
                    <ui-input-label>ИНН</ui-input-label>
                </ui-input-box-floating>



                <div class="row">


                    <div class="col-md-6">

                        <ui-input-box-floating class="mb-3" :error="getError(index, 'BeneficiaryTel')">
                            <ui-input v-model="item.BeneficiaryTel" type="text" placeholder="Телефон"
                                :disabled="disabled" />
                            <ui-input-label>Телефон</ui-input-label>
                        </ui-input-box-floating>

                    </div>

                    <div class="col-md-6">

                        <ui-input-box-floating class="mb-3" :error="getError(index, 'BeneficiaryEmail')">
                            <ui-input v-model="item.BeneficiaryEmail" type="text" placeholder="E-mail"
                                :disabled="disabled" />
                            <ui-input-label>E-mail</ui-input-label>
                        </ui-input-box-floating>

                    </div>

                </div>

                <div class="form-group mb-3">
                    <label>
                        <input v-model="item.BeneficiaryPDL" type="checkbox" name="FounderFLIsBeneficiary"
                            :disabled="disabled">
                        <span>Является публичным должностным лицом</span>
                    </label>
                </div>

            </div>

            <div class="col-md-8 col-lg-6">

                <h5>Паспорт</h5>

                <!-- <ui-input-box-floating class="mb-3">
                    <ui-input v-model="item.BeneficiaryCitizenship" type="text" placeholder="Гражданство" />
                    <ui-input-label>Гражданство</ui-input-label>
                </ui-input-box-floating> -->

                <ui-input-box-floating class="mb-3" :error="getError(index, 'BeneficiaryCitizenship')">
                    <select v-model="item.BeneficiaryCitizenship" class="form-control form-select" :disabled="disabled">
                        <option value="Российская Федерация">Российская Федерация</option>
                        <option value="Иностранный гражданин">Иностранный гражданин</option>
                    </select>
                    <ui-input-label>Гражданство</ui-input-label>
                </ui-input-box-floating>

                <ui-input-box-floating class="mb-3" :error="getError(index, 'BeneficiaryPassportSN')">
                    <ui-input v-model="item.BeneficiaryPassportSN" type="text" placeholder="Серия и номер паспорта"
                        :disabled="disabled" />
                    <ui-input-label>Серия и номер паспорта</ui-input-label>
                </ui-input-box-floating>

                <!-- <ui-input-box-floating class="mb-3" :error="getError(index, 'BeneficiaryPassPlace')">
                    <ui-input v-model="item.BeneficiaryPassPlace" type="text" placeholder="Место выдачи"
                        :disabled="disabled" />
                    <ui-input-label>Место выдачи</ui-input-label>
                </ui-input-box-floating> -->

                <Autocomplete class="mb-3" v-model="item.BeneficiaryPassPlace" type="fms_unit" label="Место выдачи"
                    placeholder="Место выдачи" :error="getError(index, 'BeneficiaryPassPlace')" :disabled="disabled"
                    @select="(d) => {
                        item.BeneficiaryPassPlace = d.value
                        item.BeneficiaryPassPCode = d.data.code || ''
                    }" />

                <div class="row">

                    <div class="col-md-6">

                        <ui-input-box-floating class="mb-3" :error="getError(index, 'BeneficiaryPassDate')">
                            <ui-input v-model="item.BeneficiaryPassDate" type="date" placeholder="Дата выдачи"
                                :disabled="disabled" />
                            <ui-input-label>Дата выдачи</ui-input-label>
                        </ui-input-box-floating>

                    </div>

                    <div class="col-md-6">

                        <!-- <ui-input-box-floating class="mb-3" :error="getError(index, 'BeneficiaryPassPCode')">
                            <ui-input v-model="item.BeneficiaryPassPCode" type="text" placeholder="Код подразделения"
                                :disabled="disabled" />
                            <ui-input-label>Код подразделения</ui-input-label>
                        </ui-input-box-floating> -->


                        <Autocomplete class="mb-3" v-model="item.BeneficiaryPassPCode" type="fms_unit"
                            label="Код подразделения" placeholder="Код подразделения"
                            :error="getError(index, 'BeneficiaryPassPCode')" :disabled="disabled" @select="(d) => {
                                item.BeneficiaryPassPlace = d.value
                                item.BeneficiaryPassPCode = d.data.code || ''
                            }" />

                    </div>

                </div>

                <!-- <ui-input-box-floating class="mb-3" :error="getError(index, 'BeneficiaryRegistration')">
                    <ui-input v-model="item.BeneficiaryRegistration" type="text" placeholder="Адрес регистрации"
                        :disabled="disabled" />
                    <ui-input-label>Адрес регистрации</ui-input-label>
                </ui-input-box-floating> -->

                <Autocomplete class="mb-3" v-model="item.BeneficiaryRegistration" type="address"
                    label="Адрес регистрации" placeholder="Адрес регистрации"
                    :error="item.errors?.BeneficiaryRegistration" :disabled="disabled"
                    @select="(d) => item.BeneficiaryRegistration = d.value" />

            </div>
        </div>

        <button @click="() => del(index)" class="btn btn-ghost btn-small mb-2"
            :disabled="Beneficiary.length == 1 || disabled">Удалить бенефициарного владельца</button>
    </div>

    <button v-if="!props.data.checkboxBeneficiary" @click="add" class="btn btn-base btn-small"
        :disabled="disabled">Добавить бенефициарного
        владельца</button>
</template>

<script setup>

import { ref, onMounted, watch } from 'vue'

import Autocomplete from "../../../component/Autocomplete/index.vue";

const props = defineProps({
    data: {
        type: Object,
        default: {}
    },
    errors: {
        type: Object,
        default: {}
    },
    disabled: {
        type: Boolean,
        default: false
    }
})

const Beneficiary = ref([])

const add = () => {
    Beneficiary.value = [...Beneficiary.value, { BeneficiaryCitizenship: 'Российская Федерация' }]
}

const del = (index) => {
    Beneficiary.value = Beneficiary.value.filter((item, itemIndex) => itemIndex !== index)
}

const getError = (index, field) =>
    props.errors?.Beneficiary?.[index]?.[field] || false


onMounted(() => {
    const isValidObjectArray =
        Array.isArray(props.data?.Beneficiary) &&
        props.data.Beneficiary.every(item => typeof item === 'object' && !Array.isArray(item))

    Beneficiary.value = isValidObjectArray
        ? props.data.Beneficiary
        : [{ BeneficiaryCitizenship: 'Российская Федерация' }]
})

watch(Beneficiary, (newValue) => {

    props.data.Beneficiary = newValue

}, { deep: true })

watch(() => props.data.checkboxBeneficiary, (newVal) => {
    if (newVal) {
        Beneficiary.value = [
            { BeneficiaryCitizenship: 'Российская Федерация' }
        ];
    }
});



</script>